import PageWrapper from "../../../../components/common/layout/PageWrapper";
import React from "react";
import { useTranslation } from "react-i18next";
import Feedback from "../../../../components/admin/feedback/Feedback";

const FeedbackManagement = () => {
  const { t } = useTranslation();

  return (
    <PageWrapper title={t("t.page.feedback.admin")}>
      <Feedback />
    </PageWrapper>
  );
};

export default FeedbackManagement;
